<template>
    <div>
        <Breadcrumb section-name="Settings" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="openModal"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <div class="modal fade" id="add" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-capitalize">{{actionType}} {{ this.$route.name }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form @submit.prevent="actionType === 'add' ? add() : edit()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="form-group mb-3 col-md-6">
                                    <label for="name" class="form-label">Name<span class="text-danger">*</span></label>
                                    <input type="text" v-model="addEditParam.name" name="name" class="form-control" id="name"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="name" class="form-label">Total Share</label>
                                    <input type="text" v-model="addEditParam.total_share" name="name" class="form-control" id="name"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="name" class="form-label">Deposit Amount</label>
                                    <input type="text" v-model="addEditParam.deposit_amount" name="name" class="form-control" id="name"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="land_description" class="form-label">Land Description</label>
                                    <input type="text" v-model="addEditParam.land_description" name="land_description" class="form-control" id="land_description"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="flat_description" class="form-label">Flat Description</label>
                                    <input type="text" v-model="addEditParam.flat_description" name="flat_description" class="form-control" id="flat_description"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="shop_description" class="form-label">Shop Description</label>
                                    <input type="text" v-model="addEditParam.shop_description" name="shop_description" class="form-control" id="shop_description"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="car_parking_description" class="form-label">Car Parking Description</label>
                                    <input type="text" v-model="addEditParam.car_parking_description" name="car_parking_description" class="form-control" id="car_parking_description"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="building_description" class="form-label">Building Description</label>
                                    <input type="text" v-model="addEditParam.building_description" name="building_description" class="form-control" id="building_description"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="document_description" class="form-label">Document Description</label>
                                    <input type="text" v-model="addEditParam.document_description" name="document_description" class="form-control" id="document_description"
                                           placeholder="Name">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="actual_price" class="form-label">Actual Price</label>
                                    <input type="text" v-model="addEditParam.actual_price" name="actual_price" class="form-control" id="actual_price"
                                           placeholder="Actual Price">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="broker_price" class="form-label">Broker Price</label>
                                    <input type="text" v-model="addEditParam.broker_price" name="broker_price" class="form-control" id="broker_price"
                                           placeholder="Broker Price">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="registration_price" class="form-label">Registration Price</label>
                                    <input type="text" v-model="addEditParam.registration_price" name="registration_price" class="form-control" id="registration_price"
                                           placeholder="Registration Price">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="other_price" class="form-label">Other Price</label>
                                    <input type="text" v-model="addEditParam.other_price" name="other_price" class="form-control" id="other_price"
                                           placeholder="Other Price">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                                <div class="form-group mb-3 col-md-6">
                                    <label for="company_minimum_price" class="form-label">Company Minimum Price</label>
                                    <input type="text" v-model="addEditParam.company_minimum_price" name="company_minimum_price" class="form-control" id="company_minimum_price"
                                           placeholder="Company Minimum Price">
                                    <small class="invalid-feedback text-danger"></small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-width" data-bs-dismiss="modal">Close
                            </button>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">{{ actionType === 'add' ? 'Save' : 'Update' }}</button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../../Common/Breadcrumb.vue";
import ApiService from "../../../Services/ApiService";
import ApiRoutes from "../../../Services/ApiRoutes";
import Table from "../../Common/Table.vue";
import ConfirmDialogue from "../../Common/confirmPopup/ConfirmDialogue.vue";
import DownloadService from "../../../Services/DownloadService";

export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: [],
            loading: false,
            addEditParam: {
                name: '',
                total_share: '',
                deposit_amount: '',
                land_description: '',
                flat_description: '',
                shop_description: '',
                car_parking_description: '',
                building_description: '',
                document_description: '',
                actual_price: '',
                broker_price: '',
                registration_price: '',
                other_price: '',
                company_minimum_price: '',
            },
            param: {
                keyword: '',
                limit: 15,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
            },
            actionType: 'Add',
            id: [],
            table: {
                alignTop: false,
                columns: [
                    {type: 'text', key: 'name', label: 'Name', sortable: true},
                    {type: 'text', key: 'total_share', label: 'Total Share', sortable: true},
                    {type: 'text', key: 'deposit_amount', label: 'Deposit Amount', sortable: true},
                    {type: 'text', key: 'land_description', label: 'Land Description', sortable: true},
                    {type: 'text', key: 'flat_description', label: 'Flat Description', sortable: true},
                    {type: 'text', key: 'shop_description', label: 'Shop Description', sortable: true},
                    {type: 'text', key: 'car_parking_description', label: 'Car Parking Description', sortable: true},
                    {type: 'text', key: 'building_description', label: 'Building Description', sortable: true},
                    {type: 'text', key: 'document_description', label: 'Document Description', sortable: true},
                    {type: 'text', key: 'actual_price', label: 'Actual Price', sortable: true},
                    {type: 'text', key: 'broker_price', label: 'Broker Price', sortable: true},
                    {type: 'text', key: 'registration_price', label: 'Registration Price', sortable: true},
                    {type: 'text', key: 'other_price', label: 'Other Price', sortable: true},
                    {type: 'text', key: 'company_minimum_price', label: 'Company Minimum Price', sortable: true},
                ],
                rows: [],
                row_actions: [
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.openModal(data.row_action, data.row_data);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                download: [
                    {
                        icon: 'xls',
                        loading: false,
                        action: () => {
                            this.downloadFile('xls')
                        }
                    },
                    {
                        icon: 'pdf',
                        loading: false,
                        action: () => {
                            this.downloadFile('pdf')
                        }
                    }
                ],
                noDataError: ' Please click "+ Add Project" to add a new Project'
            },
            sections: []
        }
    },
    methods: {
        openModal(type, data = null) {
            this.clearForm(type)
            this.id = this.structureReturnData(data)
            if (type === 'add' || type === 'edit') {
                $('#add').modal('show');
            }
            if (type === 'edit') {
                this.single()
            } else if (type === 'delete') {
                this.deleteModal()
            }
        },
        clearForm: function (type) {
            ApiService.ClearErrorHandler();
            this.actionType = type
            this.addEditParam = {
                name: '',
            }
        },
        async deleteModal() {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Are you sure you want to delete Project?',
                okButton: 'Delete',
            })
            if (ok) {
                this.delete()
            }
        },
        add: function () {
            ApiService.ClearErrorHandler();
            this.loading = true;
            ApiService.POST(ApiRoutes.Project + '/save', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    $('#add').modal('hide');
                    this.$toast.success(res.message)
                    this.list()
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        edit: function () {
            ApiService.ClearErrorHandler();
            this.loading = true;
            ApiService.POST(ApiRoutes.Project + '/update', this.addEditParam, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    $('#add').modal('hide');
                    this.list()
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
        delete: function () {
            ApiService.POST(ApiRoutes.Project + '/delete', {id: this.id[0]}, (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
        single: function () {
            ApiService.POST(ApiRoutes.Project + '/single', {id: this.id[0]}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.addEditParam = res.data
                }
            });
        },
        list: function (page) {
            if (page === undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.Project + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data
                    this.table.paginateData = res.data
                }
            });
        },
        downloadFile: function (type) {
            let route = type === 'xls' ? ApiRoutes.Project + '/export/excel' : ApiRoutes.Project + '/export/pdf'
            let name = type === 'xls' ? 'Project List.xlsx' : 'Project List.pdf'
            DownloadService.download(route, this.table.download, name, type, this.param)
        }
    },
    mounted() {
        this.list()
    },
    created() {
        this.breadCrumb.push(this.$route.name)
    }
}
</script>

<style scoped>

</style>
